import { PlusCircleIcon } from "@phosphor-icons/react";
import { lazy } from "react";

const CadastroCodigoComposto = lazy(() => import("./CodigoComposto"));
const EAN128Config = lazy(() => import("./CodigoComposto/children/EAN128Config"));
const FindEans = lazy(() => import("./CodigoComposto/children/FindEans"));
const ModalCodigoComposto = lazy(() => import("./CodigoComposto/children/Form"));
const WelcomePage = lazy(() => import("./Dashboard").then((m) => ({ default: m.WelcomePage })));
const CadastroDeposito = lazy(() => import("./Deposito"));
const ModalDeposito = lazy(() => import("./Deposito/children/Form"));
const CadastroEndereco = lazy(() => import("./Endereco"));
const CadastroEstacao = lazy(() => import("./Estacao"));
const FormEstacao = lazy(() => import("./Estacao/children/Form"));
const CadastroMotivo = lazy(() => import("./Motivo"));
const FormMotivo = lazy(() => import("./Motivo/children/Form"));
const CadastroOrdenacao = lazy(() => import("./OrdenacaoEstacao"));
const ModalSelecaoEstacao = lazy(() => import("./OrdenacaoEstacao/children/ModalSelecaoEstacao"));
const Ordenacao = lazy(() => import("./OrdenacaoEstacao/children/OrdenacaoEstacao"));
const EntradaProduto = lazy(() => import("./Produtos"));
const EmbalagemCreate = lazy(() => import("./Produtos/FormEmbalagem/create").then((m) => ({ default: m.EmbalagemCreate })));
const EmbalagemEdit = lazy(() => import("./Produtos/FormEmbalagem/edit").then((m) => ({ default: m.EmbalagemEdit })));
const ProductEdit = lazy(() => import("./Produtos/FormProduct/edit").then((m) => ({ default: m.ProductEdit })));
const ProdutosDetails = lazy(() => import("./Produtos/components/Details").then((m) => ({ default: m.ProdutosDetails })));
const UsuarioList = lazy(() => import("./Usuario"));
const UsuarioCreate = lazy(() => import("./Usuario/Components/Create").then((m) => ({ default: m.UsuarioCreate })));
const ListPermissoes = lazy(() => import("./Usuario/permissoes/ListPermissoes").then((m) => ({ default: m.ListPermissoes })));
const UsuarioPermissionCreate = lazy(() => import("./Usuario/permissoes/create").then((m) => ({ default: m.UsuarioPermissionCreate })));
const EditPermissoes = lazy(() => import("./Usuario/permissoes/edit").then((m) => ({ default: m.EditPermissoes })));

const ModuleCadastro = {
  menuItem: {
    to: "/cadastros",
    id: 1,
    title: "Cadastros",
    icon: PlusCircleIcon,
    childrens: [
      {
        to: "/cadastro/cadastro-de-depositos",
        title: "Depósitos",
        fullTitle: "Cadastro de Depósitos",
        id: 1,
      },
      {
        to: "/cadastro/cadastro-de-estacoes",
        title: "Estações",
        fullTitle: "Cadastro de Estações",
        id: 2,
      },
      {
        to: "/cadastro/cadastro-de-enderecos",
        title: "Endereços",
        fullTitle: "Cadastro de Endereços",
        id: 3,
      },

      {
        to: "/cadastro/cadastro-de-ordenacao",
        title: "Ordenação",
        fullTitle: "Cadastro de Ordenação Estação",
        id: 4,
      },

      {
        to: "/cadastro/cadastro-do-codigo-composto",
        title: "Código composto",
        fullTitle: "Código Composto",
        id: 5,
      },
      {
        to: "/cadastro/consulta-de-produtos",
        title: "Produtos",
        fullTitle: "Consulta de Produtos",
        id: 6,
      },
      {
        to: "/cadastro/cadastro-de-usuarios",
        title: "Usuários",
        id: 7,
      },
      {
        to: "/cadastro/cadastro-de-motivos",
        title: "Motivos",
        fullTitle: "Cadastro de Motivos",
        id: 8,
      },
    ],
  },

  routes: [
    {
      path: "",
      element: <WelcomePage />,
    },
    {
      path: "cadastro",
      element: <WelcomePage />,
    },
    {
      path: "/cadastro/cadastro-de-depositos",
      element: <CadastroDeposito />,
      children: [
        { path: ":id", element: <ModalDeposito /> },
        { path: "novo", element: <ModalDeposito /> },
      ],
    },
    {
      path: "/cadastro/cadastro-de-estacoes",
      element: <CadastroEstacao />,
      children: [
        { path: ":id", element: <FormEstacao /> },
        { path: "novo", element: <FormEstacao /> },
      ],
    },
    {
      path: "/cadastro/cadastro-de-enderecos",
      element: <CadastroEndereco />,
      children: [],
    },
    {
      path: "/cadastro/cadastro-de-motivos",
      element: <CadastroMotivo />,
      children: [
        { path: ":id", element: <FormMotivo /> },
        { path: "novo", element: <FormMotivo /> },
      ],
    },
    {
      path: "/cadastro/cadastro-de-ordenacao",
      element: <CadastroOrdenacao />,
      children: [
        { path: "novo", element: <ModalSelecaoEstacao /> },
        { path: ":id", element: <ModalSelecaoEstacao /> },
        { path: "novo/:idestacao", element: <Ordenacao /> },
      ],
    },
    {
      path: "/cadastro/cadastro-do-codigo-composto",
      element: <CadastroCodigoComposto />,
      children: [
        { path: "novo", element: <ModalCodigoComposto /> },
        { path: "novo/:id", element: <EAN128Config /> },
        { path: "editar", element: <ModalCodigoComposto /> },
        { path: "editar/:id", element: <EAN128Config /> },
        { path: ":codigoProduto/encontrar", element: <FindEans /> },
      ],
    },
    {
      path: "cadastro/consulta-de-produtos",
      element: <EntradaProduto />,
      children: [
        { path: ":id", element: <ProdutosDetails /> },
        { path: ":id/editar", element: <ProductEdit /> },
        {
          path: ":id/embalagem/criar",
          element: <EmbalagemCreate />,
        },
        {
          path: "embalagem/:embalagem",
          element: <EmbalagemEdit />,
        },
      ],
    },
    {
      path: "/cadastro/cadastro-de-usuarios",
      element: <UsuarioList />,
      children: [
        { path: "novo", element: <UsuarioCreate /> },
        { path: "listapermissoes/:id", element: <ListPermissoes /> },
        {
          path: "listapermissoes/:id/:idpermissao",
          element: <EditPermissoes />,
        },
        {
          path: "listapermissoes/:id/novo",
          element: <UsuarioPermissionCreate />,
        },
      ],
    },
  ],
};

export default ModuleCadastro;
